import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Box, Flex, Img, Text, useMultiStyleConfig} from '@chakra-ui/react'
import SanitizedHtml from '../html-sanitizer'
import {BRAND_KEY} from '../../brand'

let placeholderImage
switch (BRAND_KEY) {
    case 'nutribullet':
        placeholderImage = 'https://dam.delonghigroup.com/800x640/assets/339092'
        break
    case 'kenwood':
        placeholderImage = 'https://dam.delonghigroup.com/562x468/assets/236494'
        break
    default:
        placeholderImage = 'https://dam.delonghigroup.com/800x640/assets/244948'
}

const GridCard = ({image, onClick, title, variant}) => {
    const styles = useMultiStyleConfig('GridCard', {variant})
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            onClick && onClick()
        }
    }
    return (
        <Flex
            {...styles.cardContainer}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            data-testid="grid-card"
            onClick={onClick}
            role="button"
        >
            <Box {...styles.imgWrapper}>
                <AspectRatio ratio={1.5} width="100%">
                    <Box position="relative" width="100%">
                        {image ? (
                            <Img src={image} alt={title} {...styles.tileImage} />
                        ) : (
                            <Img src={placeholderImage} alt="placeholder" {...styles.tileImage} />
                        )}
                        <Box {...styles.gridCardOverlay} />
                    </Box>
                </AspectRatio>
            </Box>
            <SanitizedHtml as={Text} html={title} {...styles.cardText} sanitize={true} />
        </Flex>
    )
}

GridCard.propTypes = {
    image: PropTypes.string,
    onClick: PropTypes.func,
    title: PropTypes.string,
    variant: PropTypes.string,
}

export default GridCard
